import Line from './Line.js';
var React = require('react');
var d3 = require('d3');
var createReactClass = require('create-react-class');

var LinePath = createReactClass({
    render: function () {
        var props = this.props;
        var xScale = props.xScale;
        var yScale = props.yScale;

        var pathTotal = d3.line()
            .x(function (d) {
                return xScale(d.timeBin);
            })
            .y(function (d) {
                return yScale(d.numTweets);
            })
            .curve(d3.curveLinear);

        var pathPositive = d3.line()
            .x(function (d) {
                return xScale(d.timeBin);
            })
            .y(function (d) {
                return yScale(d.posTweets);
            })
            .curve(d3.curveLinear);

        var pathNegative = d3.line()
            .x(function (d) {
                return xScale(d.timeBin);
            })
            .y(function (d) {
                return yScale(d.negTweets);
            })
            .curve(d3.curveLinear);

        var pathNeutral = d3.line()
            .x(function (d) {
                return xScale(d.timeBin);
            })
            .y(function (d) {
                return yScale(d.neutTweets);
            })
            .curve(d3.curveLinear);

        return (
            <g>
                <Line path={pathTotal(this.props.binnedTweets)} stroke={"blue"}/>
                <Line path={pathNeutral(this.props.binnedTweets)} stroke={"sandybrown"}/>
                <Line path={pathNegative(this.props.binnedTweets)} stroke={"red"}/>
                <Line path={pathPositive(this.props.binnedTweets)} stroke={"green"}/>

            </g>
        );
    }
});

export default LinePath;